const STARS = Array.from({ length: 10 }, (_, index) => index);

export function StarSky() {
  return (
    <div className="sky" aria-hidden="true">
      {STARS.map((star) => (
        <span key={star} className="star" />
      ))}
    </div>
  );
}
